module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website-w960.57563bc8.jpg";